// extracted by mini-css-extract-plugin
module.exports = {"title":"dhsgumZj3-title"};